import axios from './axios';
import { useQuery } from 'react-query';

export type DashboardConferenceDetailsQuery =
  | 'user-consumption'
  | 'date-consumption'
  | 'department-consumption';

export type DashboardConferenceDetailsUnit =
  | 'count'
  | 'duration'
  | 'participant-duration';

const fetchConferenceDetails = <TData>(
  query: DashboardConferenceDetailsQuery,
  unit: DashboardConferenceDetailsUnit,
  filters: {
    startDate: string;
    endDate: string;
    limit: number;
  },
) =>
  axios
    .get<TData>(
      `/posht/pishkhan/meetings/${query}/${unit}/` +
        `?from_date=${filters.startDate}` +
        `&to_date=${filters.endDate}` +
        `&limit=${filters.limit}`,
    )
    .then((res) => res.data);

export interface UseDashboardConferenceDetailsProps {
  query: DashboardConferenceDetailsQuery;
  filters: {
    endDate: string;
    startDate: string;
    limit: number;
  };
  unit: DashboardConferenceDetailsUnit;
}

export function useDashboardConferenceDetails<TData>(
  props: UseDashboardConferenceDetailsProps,
) {
  const { filters, query, unit } = props;

  return useQuery<TData>(
    [query, unit, filters.startDate, filters.endDate, filters.limit],
    () => fetchConferenceDetails<TData>(query, unit, filters),
    { suspense: false },
  );
}
